import { Schema } from '@core/data/dto/schema';

export const CreateDeliveryOrderRequestSchema = {
    external_id: Schema.String,
    order_type: Schema.Auto,
    location_id: Schema.String,
    order_items: Schema.Auto,
    pickup_name: Schema.String,
    received_at: Schema.String,
    delivery_fee: Schema.Number,
    delivery_time: Schema.String,
    delivery_time_utc: Schema.String,
    order_number: Schema.String,
    pickup_phone: Schema.String,
    pickup_address: Schema.String,
    pickup_at_ready: Schema.String,
    customer_name: Schema.String,
    customer_email: Schema.String,
    customer_phone: Schema.String,
    customer_address: Schema.String,
    delivery_instruction: Schema.String,
    tip: Schema.Number,
    tax: Schema.Number,
    total: Schema.Number,
    cash_on_delivery: Schema.Boolean,
    requires_id: Schema.Boolean,
    requires_dropoff_signature: Schema.Boolean,
    deliverable_action: Schema.Auto,
    payment_methods: [Schema.String],
    providers: [Schema.String],
    driver_id: Schema.String,
    order_reference: Schema.String,
    override_manualmode: Schema.Boolean,
    override_force_assign: Schema.Boolean,
};
